import { defineComponent as _defineComponent } from 'vue'
import OptimizerIcon from '@sh/components/Utils/OptimizerIcon.ts.vue';

interface Props {
  message?: string;
  errorMessage?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NoData.ts',
  props: {
    message: { default: 'No Data Found...' },
    errorMessage: null
  },
  setup(__props: any) {



return { __sfc: true,OptimizerIcon }
}

})